import { PUBLISH_MODE } from '../utils/functions-utils';

export const baseUrl = PUBLISH_MODE?.url;

export const usersUrls = {
  sendLoginCode: `${baseUrl}/api/User/SendLoginCode`,
  login: `${baseUrl}/api/user/Login`,
  register: `${baseUrl}/api/Doctor/Register`,
  info: `${baseUrl}/api/Doctor/info?`,
  refreshToken: `${baseUrl}/api/User/RefreshToken`,
  notificationToken: `${baseUrl}/api/NotificationToken`,
  deleteNotificationToken: (fireBaseToken) =>
    `${baseUrl}/api/NotificationToken?token=${fireBaseToken}`,
  getProvince: `${baseUrl}/api/Province`
};

export const appUrls = {
  registerPatient: `${baseUrl}/api/Patient/RegisterByDoctor`,
  GlucoseChart: (id, daysAgo) =>
    `${baseUrl}/api/GlucoseChart/${id}?daysAgo=${daysAgo}`,
  selectedDayReport: (id, from, to) =>
    `${baseUrl}/api/GlucoseChart/${id}?from=${from}&to=${to}`,
  GlucoseChartAll: (id) => `${baseUrl}/api/GlucoseChart/All/${id}`,
  LogsHypo: (
    id,
    pageNumber,
    pageSize,
    Status
  ) => `${baseUrl}/api/GlucoseTest/doctor/${id}
    ?Status=${Status}&IncludeTags=false&PageNumber=${pageNumber}&PageSize=${pageSize}`,
  Logs: (id, pageNumber, pageSize) =>
    `${baseUrl}/api/GlucoseTest/doctor/${id}?PageNumber=${pageNumber}&PageSize=${pageSize}`,
  getPatient: (pageNumber, pageSize) =>
    `${baseUrl}/api/Doctor/patients?PageNumber=${pageNumber}&PageSize=${pageSize}`,
  NFCTransaction: `${baseUrl}/api/NFCTransaction/InsertByDoctor`,
  getPatientInfo: (id) => `${baseUrl}/api/Patient/${id}`,
  editPatient: (id) => `${baseUrl}/api/Patient/${id}`,
  currentUser: `${baseUrl}/api/User/CurrentUser`,
  GridGlucoseChart: (from, to, id) =>
    `${baseUrl}/api/GlucoseChart/grid/${id}?from=${from}&to=${to}`,
  GetShareToken: (id) => `${baseUrl}/api/UserShareToken/${id}?validHours=72`,
  getSharedReportData: (token) =>
    `${baseUrl}/api/SharedData/All?token=${token}`,
  getSharedLogbookData: (PageNumber, PageSize, token) =>
    `${baseUrl}/api/SharedData/Filter?PageNumber=${PageNumber}&PageSize=${PageSize}&token=${token}`,
  getSharedUserInfo: (token) => `${baseUrl}/api/SharedData/User?token=${token}`,
  getSharedGridTable: (from, to, token) =>
    `${baseUrl}/api/SharedData/grid?from=${from}&to=${to}&token=${token}`,
  sendSmsShareLink: (patientId, phoneNumber) =>
    `${baseUrl}/api/UserShareToken/${patientId}/SendTextMessage?phoneNumber=${phoneNumber}`,
  updateUserProfile: `${baseUrl}/api/User/UpdateProfile`,
  getPatientList: (pageNumber, pageSize, orderBy, searchQuery) =>
    `${baseUrl}/api/Doctor/patients?SearchQuery=${searchQuery}&OrderBy=${orderBy}&PageNumber=${pageNumber}&PageSize=${pageSize}`,
  changePhoneNumber: (number) =>
    `${baseUrl}/api/User/ChangePhoneNumber?phone=${number}`,
  activationPhoneNumber: `${baseUrl}/api/ActivationCode/VerifyChangePhoneNumber`,
  hypoData: (patientId, daysAgo) =>
    `${baseUrl}/api/GlucoseChart/hypo/${patientId}?daysAgo=${daysAgo}`,
  hypoDataCustomDate: (patientId, from, to) =>
    `${baseUrl}/api/GlucoseChart/hypo/${patientId}?from=${from}&to=${to}`,
  hypoListData: (patientId, daysAgo, status) =>
    `${baseUrl}/api/GlucoseTest/${patientId}/filterByDays?daysAgo=${daysAgo}&status=${status}`,
  HypoListCustomDate: (patientId, from, to) =>
    `${baseUrl}/api/GlucoseTest/${patientId}/filterByDate?status=2&from=${from}&to=${to}`,
  agentList: `${baseUrl}/api/Assistant`,
  agentData: (id) => `${baseUrl}/api/Assistant/${id}`,
  deleteInvite: (id) => `${baseUrl}/api/Assistant/${id}/invite`,
  agentInvie: `${baseUrl}/api/Assistant/invite`,
  sendLink: `${baseUrl}/api/Doctor/DownloadMessage`,
  notifications: (PageNumber) =>
    `${baseUrl}/api/Notification?ClientApplication=1&PageNumber=${PageNumber}&PageSize=${20}`,
  notification: `${baseUrl}/api/Notification`,
  deleteSpecificNotif: (id) => `${baseUrl}/api/Notification/${id}`,
  deleteNotifs: `${baseUrl}/api/Notification`,
  appType: `${baseUrl}/api/Test/env`,
  getCurrentTime: `${baseUrl}/api/Tools/Time`,
};

export const ascvdUrl = `${PUBLISH_MODE?.calculatorURL}/api/Risks/CalculateRisks`;
